import { useQuery } from '@tanstack/react-query'
import { gamificationApi } from '../api/gamification.api'

export const GAMIFICATION_KEY = ['gamification'] as const

export function useGamification() {
  return useQuery({
    queryKey: GAMIFICATION_KEY,
    queryFn: () => gamificationApi.fetchProfile().then((r) => r.data.data),
    staleTime: 60_000,
  })
}
